mutation PublishWorkBlock($workBlockId: ID!) {
  publishWorkBlock(workBlockId: $workBlockId) {
    publishedWorkBlock {
      createdId
      updatedId
      success
      workBlock {
        id
        jobId
        startsAt
        line {
          name
        }
        workOrder {
          code
        }
      }
      errors {
        message
        path
      }
    }
  }
}
